import React from 'react';
import { siteConfig } from './config';

const ReviewsPage = ({ isDarkMode = false }) => {
  const reviews = [
    {
      id: 1,
      name: "Anonymous Guest",
      rating: 5,
      date: "2024-08-01",
      comment: "Lekker plekkie net weg van die gewoel van die dorpie maar tog baie naby!"
    },
    {
      id: 2,
      name: "Jake Pretorius, Pretoria",
      rating: 5,
      date: "2024-07-15",
      comment: "Ons het die langnaweek terdeë geniet. Plekkie is skoon, netjies en goed toegerus. Heerlikste stofie wat jou warm hou. Die sonsondergange is om van liries te raak. Thanks Barry and Jen!"
    },
    {
      id: 3,
      name: "Natalie Miles, Australia",
      rating: 5,
      date: "2024-07-10",
      comment: "Such a lovely stay! The views are great and the birds feeding is very pretty. Our hosts were very friendly and advised of places to go and explore. The lodge was very nice and better than a lot of 5 Star hotels that we have stayed at during our trip. Thank you! Hope to see you again!"
    },
    {
      id: 4,
      name: "Elsette Strachan, South Africa",
      rating: 5,
      date: "2024-06-20",
      comment: "Knus, gerieflik, ideaal vir 2 persone. Ons het 2 aande by J&B Lodge gebly, na 'n week in Lesotho. Dit was soos paradys. Aandag aan detail, baie goed toegerus met pragtige uitsig oor die berge. Barry se persoonlike aandag aan detail word baie waardeer. Kyk gerus na hulle webblad, 'n getroue weergawe van die plek en diens."
    },
    {
      id: 5,
      name: "Hans en Elly de Gelder, Netherlands",
      rating: 5,
      date: "2024-06-15",
      comment: "Verblijf om naar de Sani pas te gaan. Barry verwelkomde ons zeer hartelijk. De accomodatie ligt naast zijn huis, is heel schoon en heeft geweldig uitzicht, o.a. op de Drakensberge. We voelden ons vrij en comfortabel in het ruime huisje met stoep! Wat een rust. Lekker zonnig. Lekker eten en gezellig: in de golfclub aan de overkant van de weg. Allebei warm aanbevolen!"
    },
    {
      id: 6,
      name: "Arnie Rush, Canada",
      rating: 5,
      date: "2024-05-25",
      comment: "Ten from us! An axing place in every aspect. Wonderful hosts. Fantastic views. Very comfortable. Well located for privacy and convenience. Definitely a \"TEN\" for us!"
    },
    {
      id: 7,
      name: "Mike Cope, South Africa",
      rating: 5,
      date: "2024-05-20",
      comment: "We will be back soon! Wonderful, peaceful rest, lovely hosts Jen and Barry, very comfortable with awesome views and can highly recommend, thanks, we will be back soon."
    },
    {
      id: 8,
      name: "Colleen Browne, South Africa",
      rating: 5,
      date: "2024-05-10",
      comment: "Beautiful Views. Beautiful views of Rhino Horn and Hodgson Peak while having a braai on the deck. Comfortable and well equipped self catering. Very central for day trips and 5min away from Spar to stock up on food and wine or have a curry at The Country club."
    },
    {
      id: 9,
      name: "Nadine Laroy, South Africa",
      rating: 5,
      date: "2024-04-30",
      comment: "Magnificent landscape. Waking up to a magnificent landscape, very friendly hosts, Barry & Jennifer making sure we have every single thing we need, and the cottage cosy, comfortable and missing nothing! We'll be back!"
    },
    {
      id: 10,
      name: "Reinhard Dembskey, South Africa",
      rating: 5,
      date: "2024-04-25",
      comment: "Had a lovely stay with J&B lodge! We were greeted by friendly hosts and everything that we needed with beautiful views of the Drakensburg!"
    },
    {
      id: 11,
      name: "Kyle Rimmer, South Africa",
      rating: 5,
      date: "2024-04-20",
      comment: "Warm hospitality from Jennifer and Barry. The silence and beauty of the views from the lovely J&B Lodge was only shadowed by the warm hospitality from Jennifer and Barry as well as their two very friendly dogs, Oscar and Holly. Thank you for a truly relaxing stay."
    },
    {
      id: 12,
      name: "Susan de Wet, South Africa",
      rating: 5,
      date: "2024-04-15",
      comment: "We enjoyed our stay at J & B Lodge immensely! We will definitely return as soon as possible."
    }
  ];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`w-5 h-5 ${index < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  const averageRating = reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length;

  return (
    <div className={`min-h-screen font-sans ${isDarkMode ? 'bg-gray-900' : ''}`} style={!isDarkMode ? { backgroundColor: '#f6f2ec' } : {}}>
      {/* Hero Section */}
      <div className="relative h-[400px] w-full overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <div className="relative h-full flex items-center justify-center">
            <div className="text-center text-white px-4">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 leading-tight">
                Guest Reviews
              </h1>
              <p className="text-xl md:text-2xl font-medium opacity-90">
                What our guests say about {siteConfig.siteTitle}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      <div className="max-w-[80rem] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Overall Rating */}
        <div className="text-center mb-16">
          <div className={`rounded-lg shadow-lg p-8 max-w-2xl mx-auto ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-3xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Overall Rating</h2>
            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center">
                {renderStars(Math.round(averageRating))}
                <span className={`ml-2 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  {averageRating.toFixed(1)}
                </span>
              </div>
            </div>
            <p className={`text-lg ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Based on {reviews.length} guest reviews
            </p>
          </div>
        </div>

        {/* Individual Reviews */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div key={review.id} className={`rounded-lg shadow-lg p-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
              <div className="flex items-center justify-between mb-4">
                <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                  {review.name}
                </h3>
                <span className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  {new Date(review.date).toLocaleDateString()}
                </span>
              </div>
              <div className="flex items-center mb-4">
                {renderStars(review.rating)}
              </div>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                {review.comment}
              </p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className={`rounded-lg shadow-lg p-8 max-w-2xl mx-auto ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
            <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Share Your Experience</h3>
            <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              We'd love to hear about your stay! Leave us a review and help other travelers discover the perfect accommodation.
            </p>
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('openBookingModal'))}
              className="px-8 py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Book Your Stay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsPage; 